import kamala from '../../kamala'
import Select from './Select'
import Optgroup from './Optgroup'
import Option from './Option'

const KSelectFamily = {
  install: function (Vue) {
    kamala(Vue)
    Vue.component(Select.name, Select)
    Vue.component(Optgroup.name, Optgroup)
    Vue.component(Option.name, Option)
  },
  KSelect: Select,
  KOptgroup: Optgroup,
  KOption: Option,
}

export {
  Select,
  Optgroup,
  Option,
}

export default KSelectFamily
